import apiHandler from "../core/apiHandler";

const rolesApi = apiHandler('roles');
export default rolesApi;
